module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp2_9016.9dd3dc54.png";